import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue"
import AppDetailPage from "@/components/layout/AppDetailPage.vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import { useTranslation } from "@/i18n/useTranslation"
import ExpansionPanels from "@/components/widgets/accordion/ExpansionPanels.vue"
import ExpansionPanel from "@/components/widgets/accordion/ExpansionPanel.vue"
import ExpansionHeader from "@/components/widgets/accordion/ExpansionHeader.vue"
import ExpansionContent from "@/components/widgets/accordion/ExpansionContent.vue"
import useRouter from "@/router/useRouter"
import { useQuery } from "@vue/apollo-composable"
import {
  MissionStaffingPositionsQuery,
  FindMissionStaffingPositionQuery,
  FindMissionStaffingPositionQueryQuery,
  MissionStaffingPositionBasicFragmentFragment,
} from "@/gql"
import { PageState } from "@/constants"
import { usePageState } from "@/hooks/usePageState"
import { useUtilities } from "@/hooks/useUtilities"
import { useCountry } from "@/hooks/useCountry"
import ApplyForRoleModal from "../ApplyForRoleModal.vue"
import ApplyButton from "../ApplyButton.vue"
import { buildPrn } from "@/helpers/idHelpers"


export default /*#__PURE__*/_defineComponent({
  __name: 'OpportunityDetailsPage',
  setup(__props) {

const { routes, router } = useRouter()
const { timeAgo, formatDate } = useUtilities()
const { getCountryByCode } = useCountry()

const { t } = useTranslation("Consultant/OpportunityDetails")

const scopeSummary = ref(0)
const showConfirmModal = ref(false)

const pageState = ref(PageState.Loading)

const staffingPosition = ref<MissionStaffingPositionBasicFragmentFragment | null>(null)

const { loading, onResult, onError } = useQuery<FindMissionStaffingPositionQueryQuery>(
  FindMissionStaffingPositionQuery,
  {
    id: buildPrn("MissionStaffingPosition", router.currentRoute.params.id),
  }
)

const refetchQueries = computed(() => [
  {
    query: MissionStaffingPositionsQuery,
    variables: {
      filter: { id: router.currentRoute.params.id },
    },
  },
])

const country = computed(() => {
  if (!staffingPosition.value?.missionLifecycle.projectLocationCountryCode) return null
  return getCountryByCode(staffingPosition.value?.missionLifecycle.projectLocationCountryCode)
})

const tags = computed(() => {
  return [
    staffingPosition.value?.missionLifecycle.scopeService?.serviceGroup?.name,
    staffingPosition.value?.missionLifecycle.scopeService?.name,
    ...(staffingPosition.value?.missionLifecycle.tagList || []),
    ...(staffingPosition.value?.requiredExpertise.map((expertise) => expertise.name) || []),
  ].filter((tag): tag is string => !!tag)
})

const { handlePageErrorState } = usePageState(pageState)

onError((error) => {
  handlePageErrorState(error)
})

onResult((result) => {
  if (result.data?.findMissionStaffingPosition) {
    staffingPosition.value = result.data.findMissionStaffingPosition
  }
})

const isApplication = computed(() => {
  return !!staffingPosition.value?.missionStaffingApplication
})

return { __sfc: true,routes, router, timeAgo, formatDate, getCountryByCode, t, scopeSummary, showConfirmModal, pageState, staffingPosition, loading, onResult, onError, refetchQueries, country, tags, handlePageErrorState, isApplication, AppDetailPage, Icon, ExpansionPanels, ExpansionPanel, ExpansionHeader, ExpansionContent, PageState, ApplyForRoleModal, ApplyButton }
}

})